import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "18",
  fill: "none",
  viewBox: "0 0 19 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "#FF6A39",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        d: "M11.732 2.557c.163.095.24.29.184.471l-1.463 4.756h2.7a.406.406 0 0 1 .295.684l-6.5 6.906a.406.406 0 0 1-.684-.398l1.463-4.755h-2.7a.406.406 0 0 1-.295-.685l6.5-6.906a.406.406 0 0 1 .5-.073"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M2.09 2.002h14v14h-14z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }